import { debounce } from "lodash";
import { useCallback, useState } from "react";
import AuthMpProvider from "@/core/data-provider/data-mp/auth/auth-mp-provider";
import useErrorTranslation from "@/core/helpers/useErrorTranslation";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response";

export default function useCheckEmail() {
  const tError = useErrorTranslation();
  const [isPending, setIsPending] = useState(false);
  const [isCompleted, setIsCompleted] = useState<null | boolean>(null);
  const [error, setError] = useState("");
  const [isExistEmail, setIsExistEmail] = useState(false);

  const checkEmail = useCallback(
    debounce(async (email: string) => {
      try {
        setIsExistEmail(false);
        setIsPending(true);
        const response = await AuthMpProvider.checkEmail(email);
        if (response instanceof RpcMpProviderSuccessResponse) {
          setIsExistEmail(response.data.isEmailExist);
          setIsCompleted(true);
        } else {
          setIsCompleted(false);
        }
      } catch (e) {
        setIsCompleted(false);
        setError(tError(e.message));
      } finally {
        setIsPending(false);
      }
    }, 300),
    [],
  );

  return { checkEmail, isPending, isCompleted, error, isExistEmail };
}
